import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Handle = ({ disabled }) => (
  <span
    className={classNames('service-table__handle', {
      'service-table__handle-disabled': disabled,
    })}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M7 2c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm0 6c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm0 6c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm6-8c1.104 0 2-.896 2-2s-.896-2-2-2-2 .896-2 2 .896 2 2 2zm0 2c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm0 6c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2z" />
    </svg>
  </span>
);

Handle.propTypes = {
  disabled: PropTypes.bool,
};

export default SortableHandle((props) => <Handle {...props} />);
